import { styled } from '@mui/material';
import * as React from 'react';

import { COLORS } from '@/styles/tokens/colors';
import { zIndexes } from '@/styles/zIndexes';

import { SIDEBAR_ANIMATION_TIMING_MS } from './sidebarConstants';

export const MENU_ITEMS_ID = 'sidebar-menu-items';

export type SidebarVariant = 'dark' | 'light';

interface StyledSidebarProps extends React.HTMLProps<HTMLDivElement> {
  width: number;
}

export const StyledSidebar = styled('nav')<StyledSidebarProps>(
  ({ theme: _, width }) => ({
    height: '100vh',
    backgroundColor: COLORS.GRAY[50],
    borderRight: `1px solid ${COLORS.NAVY[100]}`,
    transition: `width ${SIDEBAR_ANIMATION_TIMING_MS}ms ease-in-out`,
    width: width,
    zIndex: zIndexes.MENU + 1, // above the AppBar
    position: 'relative',
    '@media print': {
      display: 'none',
    },
  })
);

interface SidebarWithContainerProps extends React.HTMLProps<HTMLDivElement> {
  expansionState: SidebarExpansionState;
  width: number;
  collapsedWidth: number;
}

type SidebarExpansionState = 'collapsed' | 'expanded';

export function SidebarWithContainer({
  expansionState,
  children,
  width: expandedWidth,
  collapsedWidth,
  // there's a type incompatibility with this type that's not even used, so stripping it off here
  // to allow us to use the ...rest operator for other native properties.
  as: _as,
  ...nativeProps
}: React.PropsWithChildren<SidebarWithContainerProps>) {
  const displayedWidth =
    expansionState === 'collapsed' ? collapsedWidth : expandedWidth;

  return (
    <div
      style={{
        maxWidth: displayedWidth,
        transition: `max-width ${SIDEBAR_ANIMATION_TIMING_MS}ms ease-in-out`,
        overflow: 'hidden',
      }}
    >
      <StyledSidebar {...nativeProps} width={displayedWidth}>
        {children}
      </StyledSidebar>
    </div>
  );
}
